<template>
  <div id="home">
    <v-container grid-list-xl fluid class="pa-0">
      <v-layout row wrap>
        <v-flex lg2 sm12 xs12>
          <v-card class="elevation-4" v-if="true">
            <v-toolbar dense color="primary" dark flat>
              <v-toolbar-title>{{ $t("otros.filtrar") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                class="pt-0"
                v-model="search"
                append-icon="search"
                :label="$t('otros.filtrar')"
                single-line
                hide-details
                color="primary"
                v-if="isMobile"
              ></v-text-field>

              <b-row class="my-1 pt-2">
                <b-col sm="3">
                  <label for="input-valid">{{
                    $t("servicios.filtros.fechaInicio")
                  }}</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    ref="filtroFechaInicio"
                    autocomplete="off"
                    id="FechaInicio"
                    type="date"
                    v-model="filtro.FechaInicio"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label for="input-valid">{{
                    $t("servicios.filtros.fechaFin")
                  }}</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    ref="filtroFechaFin"
                    autocomplete="off"
                    id="FechaFin"
                    type="date"
                    v-model="filtro.FechaFin"
                  ></b-form-input>
                </b-col>
              </b-row>

              <v-select
                v-model="filtro.Estados"
                :items="estados"
                attach
                chips
                :label="$t('servicios.cabecera.estado')"
                multiple
              />
              <v-text-field
                :label="$t('servicios.cabecera.poblacion')"
                v-model="filtro.Poblacion"
                class="pt-0"
              />
              <v-text-field
                :label="$t('servicios.cabecera.referencia')"
                v-model="filtro.Referencia"
                class="pt-0"
              />
              <v-text-field
                :label="$t('servicios.cabecera.nOrder')"
                v-model="filtro.Numero"
                class="pt-0"
              />
            </v-card-text>
            <v-btn color="primary" block @click="ValidarFechasYBuscar">{{
              $t("servicios.filtros.buscar")
            }}</v-btn>
          </v-card>
        </v-flex>
        <v-flex lg10 sm12 xs12 :class="isMobile ? '' : 'ml-0 pl-0'">
          <v-card class="elevation-4">
            <v-toolbar :extended="false" color="primary" dark dense flat>
              <v-toolbar-title v-if="!cargando">{{
                $t("servicios.tusServicios")
              }}</v-toolbar-title>
              <half-circle-spinner
                v-if="cargando"
                :animation-duration="1000"
                :size="30"
                color="#FFF"
              />
              <v-toolbar-title v-if="cargando">{{
                $t("servicios.refrescando")
              }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="!isMobile"
                class="pt-0 pr-2"
                v-model="search"
                append-icon="search"
                :label="$t('otros.filtrar')"
                single-line
                hide-details
                color="white"
              ></v-text-field>
            </v-toolbar>

            <v-card-text class="pa-0" v-if="servicios">
              <!-- Elementos de la tabla -->
              <v-data-table
                :headers="headers"
                :items="servicios"
                :rows-per-page-items="pages"
                :pagination.sync="pagination"
                :hide-headers="isMobile"
                :search="search"
                :class="{ mobile: isMobile }"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : '',
                        'text-xs-left',
                        'pa-0'
                      ]"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ $t("servicios.cabecera." + header.text) }}
                    </th>
                  </tr>
                </template>

                <template v-slot:items="props">
                  <tr v-if="!isMobile">
                    <td class="text-xs-left   pl-3 pt-0 pb-0 pr-1">
                      {{ props.item.Codigo }}
                    </td>
                    <td class="text-xs-left   pl-1 pt-0 pb-0 pr-1">
                      {{ props.item.Referencia }}
                    </td>
                    <td class="text-xs-left   pl-1 pt-0 pb-0 pr-1">
                      {{ props.item.Destinatario.Nombre }}
                    </td>
                    <td class="text-xs-center pl-1 pt-0 pb-0 pr-1">
                      {{ formatDate(props.item.Fecha) }}
                    </td>
                    <td class="text-xs-center pl-1 pt-0 pb-0 pr-1">
                      {{ formatDate(props.item.FechaPrevista) }}
                    </td>
                    <td class="text-xs-left   pl-1 pt-0 pb-0 pr-1">
                      {{ props.item.TipoServicio.name }}
                    </td>
                    <td class="text-xs-left   pl-1 pt-0 pb-0 pr-1">
                      {{ props.item.Destinatario.Poblacion }}
                    </td>
                    <td class="text-xs-left   pl-1 pt-0 pb-0 pr-1">
                      {{ props.item.TextoIncidencia }}
                    </td>
                    <td class="text-xs-center pl-1 pt-0 pb-0 pr-1">
                      <v-chip
                        label
                        small
                        :color="getColorByStatus(props.item.Estado)"
                        text-color="white"
                        >{{ props.item.Estado }}</v-chip
                      >
                    </td>
                    <td class="text-xs-left pa-0 ma-0" style="min-width:200px">
                      <v-tooltip bottom>
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="showTracking(props.item)"
                        >
                          <v-icon>location_on</v-icon>
                        </v-btn>
                        <span>{{ $t("servicios.acciones.tracking") }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr v-else>
                    <v-layout wrap text-xm-left class="pt-2">
                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.nOrder") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          props.item.Codigo
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.referencia") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          props.item.Referencia
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.destinatario") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          props.item.Destinatario.Nombre
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.fecha") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          formatDate(props.item.Fecha)
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.tipoServicio") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          props.item.TipoServicio.name
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.destinatario") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">{{
                          props.item.Destinatario.Poblacion
                        }}</v-card-text>
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.textoIncidencia") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">
                          {{ props.item.TextoIncidencia }}</v-card-text
                        >
                      </v-flex>

                      <v-flex xs4>
                        <v-card-text class="pt-0 pb-1">
                          <b>{{ $t("servicios.cabecera.estado") }}:</b>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <v-card-text class="pt-0 pb-1">
                          <v-chip
                            label
                            small
                            :color="getColorByStatus(props.item.Estado)"
                            text-color="white"
                            >{{ props.item.Estado }}</v-chip
                          >
                        </v-card-text>
                      </v-flex>
                    </v-layout>

                    <td class="px-0">
                      <v-tooltip
                        bottom
                        v-if="props.item.Estado === 'Entregado'"
                      >
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="imprimirPOD(props.item)"
                        >
                          <v-icon>photo_camera</v-icon>
                        </v-btn>
                        <span>{{ $t("servicios.acciones.imprimirPOD") }}</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="props.item.Estado !== 'Eliminado'"
                      >
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="imprimir(props.item)"
                        >
                          <v-icon>print</v-icon>
                        </v-btn>
                        <span>{{
                          $t("servicios.acciones.imprimirEtiqueta")
                        }}</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="props.item.Estado !== 'Eliminado'"
                      >
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="goToUpdateService(props.item)"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <span>{{
                          $t("servicios.acciones.editarServicio")
                        }}</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="showTracking(props.item)"
                        >
                          <v-icon>location_on</v-icon>
                        </v-btn>
                        <span>{{ $t("servicios.acciones.tracking") }}</span>
                      </v-tooltip>

                      <v-tooltip
                        bottom
                        v-if="props.item.Estado !== 'Eliminado'"
                      >
                        <v-btn
                          flat
                          icon
                          color="secondary"
                          slot="activator"
                          @click="btnDeleteService(props.item)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t("servicios.acciones.eliminar") }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-text v-if="!servicios">{{
              $t("servicios.noHayServicios")
            }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <br v-if="isMobile" />

    <v-dialog v-model="dialogConfirmacionEliminar" width="450px">
      <confirmacion-modal
        @aceptar="deleteService"
        @cancelar="dialogConfirmacionEliminar = false"
      />
    </v-dialog>

    <v-dialog v-model="dialogTraking2" width="1050px">
      <service-tracking
        :servicio="servicioSeleccionado"
        @cerrar="dialogTraking2 = false"
      />
    </v-dialog>

    <v-dialog v-model="dialogPodPDF" width="80%">
      <v-card>
        <v-toolbar card dense dark color="primary">
          <v-toolbar-title class="white--text">{{
            $t("servicios.imagenPOD")
          }}</v-toolbar-title>
          <v-spacer />
          <v-btn
            fab
            dark
            small
            color="primary"
            @click="$refs.myPdfComponent.print()"
          >
            <v-icon dark>print</v-icon>
          </v-btn>
          <v-btn fab dark small color="primary" @click="dialogPodPDF = false">
            <v-icon dark>close</v-icon>
          </v-btn>
        </v-toolbar>
        <pdf
          ref="myPdfComponent"
          :src="pdfSrc"
          style="width: 100%; height= 80%"
        ></pdf>
      </v-card>
    </v-dialog>

    <image-modal
      :title="$t('servicios.imagenPOD')"
      :imgB64="imagePod"
      ref="ImageModal"
      @cerrar="dialogPod = false"
    />
  </div>
</template>

<script>
import ServiceItem from "./ServiceItem";
import { mapMutations, mapActions, mapState } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import VueFriendlyIframe from "vue-friendly-iframe";
import ServiceTracking from "./ServiceTracking";
import ConfirmacionModal from "./../ConfirmacionModal";
import UploadButton from "../UploadButton";
import ImageModal from "../ImageModal";
import pdf from "vue-pdf";

export default {
  name: "ServiceList",
  components: {
    ServiceItem,
    HalfCircleSpinner,
    VueFriendlyIframe,
    ServiceTracking,
    ConfirmacionModal,
    UploadButton,
    ImageModal,
    pdf
  },
  props: {
    servicios: {
      type: Array,
      required: true
    },
    cargando: {
      type: Boolean,
      required: true
    },
    filtro: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      search: "",
      dialogTraking2: false,
      dialogPodPDF: false,
      baseTracking: "https://erp.szendex.com/DlWebTrackingVWE/",
      urlTraking: "https://erp.szendex.com/DlWebTrackingVWE/",
      servicioSeleccionado: {},

      dialogConfirmacionEliminar: false,
      servicioSeleccionadoEliminar: {},

      imagePod: "",

      headers: [
        { sortable: true, text: "nOrder", value: "Codigo" },
        { sortable: true, text: "referencia", value: "Referencia" },
        { sortable: true, text: "destinatario", value: "Destinatario.Nombre" },
        { sortable: true, text: "fecha", value: "Fecha" },
        { sortable: true, text: "fechaPrevista", value: "FechaPrevista" },
        {
          sortable: true,
          text: "tipoServicio",
          value: "TipoServicio.name"
        },
        { sortable: true, text: "poblacion", value: "Destinatario.Poblacion" },
        { sortable: true, text: "textoIncidencia", value: "textoIncidencia" },
        { sortable: true, text: "estado", value: "Estado" },
        { sortable: false, text: "acciones" }
      ],
      pages: [25, 50, 100, { text: "Todo", value: -1 }],
      pagination: {
        sortBy: "Poblacion"
      },
      estados: [
        "Canalizado Nuevo Destino",
        "Destruido",
        "Devuelto",
        "Documentado",
        "Eliminado",
        "En Destino",
        "En Reparto",
        "En Transito",
        "Entregado",
        "Fallido",
        "Falta",
        "Falta Cliente",
        "Incidencia",
        "Localizado",
        "Pendiente Recoger En Agencia",
        "Perdido",
        "Sobra",
        "Verificado"
      ],
      pdfSrc: ""
    };
  },
  methods: {
    formatDate(value) {
      if (!value) return "";

      const datePart = String(value).split("T")[0];
      if (datePart === "0001-01-01" || datePart === "2000-01-01") return "";

      return datePart;
    },
    ValidarFechasYBuscar() {
      if (
        !this.$refs["filtroFechaInicio"].checkValidity() ||
        this.filtro.FechaInicio === ""
      ) {
        this.$toast("La fecha inicio no es válida", { color: "red" });
        return;
      }
      if (
        !this.$refs["filtroFechaFin"].checkValidity() ||
        this.filtro.FechaFin === ""
      ) {
        this.$toast("La fecha fin no es válida", { color: "red" });
        return;
      }
      this.$emit("recargar");
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async imprimirPOD(item) {
      let pod = await this.obtenerPod(item);
      if (pod.extension === "PDF") {
        this.pdfSrc = { data: atob(pod.data) };
        if (this.pdfSrc) this.dialogPodPDF = true;
      } else {
        this.imagePod = pod.data;
        if (this.imagePod) this.$refs.ImageModal.open();
      }
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    btnDeleteService(item) {
      this.servicioSeleccionadoEliminar = item;
      this.dialogConfirmacionEliminar = true;
    },
    async deleteService() {
      this.dialogConfirmacionEliminar = false;
      let ok = await this._deleteService(this.servicioSeleccionadoEliminar);
      if (ok) this.$emit("recargar");
    },
    showTracking(item) {
      this.servicioSeleccionado = item;
      this.urlTraking = this.baseTracking + "?seg=" + item.ReferenciaVia;
      this.dialogTraking2 = true;
    },
    getColorByStatus(status) {
      switch (status) {
        case "Falta":
          return "orange";
        case "Fallido":
          return "red";
        case "Eliminado":
          return "blue-grey";
        case "Entregado":
          return "green";
        case "Documentado":
          return "blue";
        case "En Reparto":
          return "deep-purple";
      }
      return "teal";
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    goToUpdateService(item) {
      this.setService(item);
      this.$router.push({
        name: "service-update",
        params: { id: item.id }
      });
    },
    updateServiceStatus(item) {
      this._updateServiceStatus(item);
    },
    removeService() {
      this._removeService(this.Service.id);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async imprimir(item) {
      this.$store.commit("setLoading", true, { root: true });
      //let numeroExpedicion = "100600097583000001";
      let numeroExpedicion = item.ReferenciaVia;
      let numeroOrden = item.Codigo;
      let ruta =
        this.$apiRoute +
        "expediciones/etiqueta?numeroExpedicion=" +
        numeroExpedicion +
        "&numeroOrden=" +
        numeroOrden;

      let res = await fetch(ruta, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("_token")
        }
      });

      if (!res.ok) {
        this.$store.commit("setLoading", false, { root: true });
        this.$toast("No se pudo imprimir", { color: "blue" });
        return;
      }

      let b64 = await res.json();
      b64 = "data:application/pdf;base64," + b64.ImprimirEtiqueta;
      res = await fetch(b64);
      let response = await res.blob();
      let blob = new Blob([response], { type: "application/pdf" });
      var fileUrl = URL.createObjectURL(blob);
      var wnd = window.open(fileUrl, "_blank");
      this.$store.commit("setLoading", false, { root: true });

      await this.sleep(500);
      wnd.print();

      /*let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Etiqueta-" + numeroExpedicion + ".pdf";*/
      //link.click();
    },
    ...mapActions({
      _updateServiceStatus: "services/updateServicioStatus",
      _deleteService: "services/deleteService",
      importarServicio: "services/importarServicio",
      obtenerPod: "services/obtenerPod"
    }),
    ...mapMutations("services", ["setService"])
  },
  computed: {
    ...mapState(["isMobile"])
  }
};
</script>

<style>
.vue-friendly-iframe iframe {
  width: 100%;
  height: 1500px;
}
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid lightgray;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid #0c2747;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
